export default __webpack_public_path__ + "static/media/flower-8.2d5006e7.svg";